import range from 'lodash/range.js';

function fitColumns(aspectRatio, numItems) {
	if (numItems < 2) return 1;

	const aspectRatios = range(1, numItems + 1).map((c) => {
		const rows = Math.ceil(numItems / c);
		const rAr = c / rows;
		return Math.abs(rAr - aspectRatio);
	});

	const min = Math.min(...aspectRatios);
	const minIndex = aspectRatios.indexOf(min) + 1;
	return minIndex;
}

export default fitColumns;
